import config from 'configs';
import { LOADING, LOADED } from 'constants/data';
import { isMobile } from 'utils';

import { SET_BANNERS_DATA, SET_BANNERS_LOADING_STATUS } from './actionTypes';

const {
  cms: { url, baseHost },
} = config;

export const fetchBannersData = () => async dispatch => {
  dispatch({
    type: SET_BANNERS_LOADING_STATUS,
    payload: LOADING,
  });

  try {
    const res = await fetch(
      `${url}/json?base_host=${baseHost}&ssl=1&lang=arm&json=widgets/get_sidebar&sidebar_id=${
        isMobile ? 'mobile-banner-homepage' : 'homepage-selected-game'
      }-arm&with_main=1`,
    );
    const banners = await res.json();
    const bannersData = banners.widgets.map(({ instance }) => instance);

    dispatch({
      type: SET_BANNERS_DATA,
      payload: bannersData,
    });
  } catch (err) {
    console.error(err);
  } finally {
    dispatch({
      type: SET_BANNERS_LOADING_STATUS,
      payload: LOADED,
    });
  }
};
